/* PawDent — פס הודעות: ספירה לאחור עד מועד סיום המבצע. */
(function () {
  'use strict';

  function initBar(bar) {
    if (bar.dataset.panInit === 'true') return;
    bar.dataset.panInit = 'true';

    var end = bar.dataset.panEnd;
    var timer = bar.querySelector('[data-pan-timer]');
    var digits = bar.querySelector('[data-pan-digits]');
    if (!end || !timer || !digits) return;

    var endMs = Date.parse(end.replace(' ', 'T'));
    if (isNaN(endMs)) return;

    timer.hidden = false;
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var iv = null;

    function tick() {
      var diff = Math.floor((endMs - Date.now()) / 1000);
      if (diff <= 0) {
        var mode = bar.dataset.panExpired || 'hide-timer';
        if (mode === 'hide-bar') bar.hidden = true;
        else if (mode === 'hide-timer') timer.hidden = true;
        else digits.textContent = '00:00:00';
        if (iv) clearInterval(iv);
        return;
      }
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      digits.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    tick();
    iv = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-pan]').forEach(initBar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-pan]').forEach(function (el) {
      try { initBar(el); } catch (err) { console.error('pan init', err); }
    });
  });
})();
